import { useTheme } from "styled-components";

export default function Timer({ time, success }) {
  const currentTheme = useTheme();
  let color = success === "Success!" ? "text-green-300" : "text-red-300";
  return (
    <div className="mx-auto w-min mt-6 text-center">
      <div className={`text-6xl ${currentTheme.textSecondary}`}>
        {time}
        <span className={`text-2xl ml-1 ${currentTheme.textPrimary}`}>s</span>
      </div>
      <p className={`font-mono font-medium text-2xl mt-6 pl-1 ${color}`}>
        {success}
      </p>
    </div>
  );
}
